import { createFileRoute } from '@tanstack/react-router'
import Documentation from 'Integration/components/Documentation'

export const Route = createFileRoute('/integrations/documentation')({
    component: Documentation,
})
